import {condition, request} from "../../../res/rest/restRequest";
import {api} from "../../../res/rest/api";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import ProductPurchaseInfoRequest from "../../services/rest/request/product/productPurchaseInfoRequest";
import solrProductRequest from "../../services/rest/request/product/solrProductRequest";

const getPrices = async (session, orderID, cart) => {
    const pnq  = cart.lines.map(l => ({p: l.M_Product_ID.id, q: l.QtyOrdered}));
    const bpID = session.bPartnerID;

    const req = request.process("getwebprices");
    req.param("products", pnq);
    req.param("c_bpartner_ID", bpID);
    req.param("c_order_id", orderID);
    const url = env.API_URL + req.buildRequest();

    const resp = await HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));
    return resp.data.data;
}

const attachProducts = async (session, orderID, cart) => {
    if(!cart?.lines || cart.lines.length <= 0) return;

    // We dont just use byPID as it only has one entry each, want to make sure we show
    // any bugged orders that have more than one line per product
    const pidToLine = cart.lines.reduce((map, line) => {
        const key = line.M_Product_ID?.id;
        if(!key) return map;
        if(!(key in map)) map[key] = [];
        map[key].push(line);
        return map;
    }, {})

    const solrList = Object.keys(pidToLine);
    if (solrList.length === 0) return;

    const { products } = await solrProductRequest()
        .pageSize(Object.keys(cart).length + 10)
        .productIDs(solrList)
        .queryMatching("Table_Name", "M_Product")
        .sendRequest();

    const purchaseRequest = await ProductPurchaseInfoRequest(session.orgID, session.bPartnerID)
        .productIDs(products.map(p => p.id))
        .sendRequest(session);
    const purchaseInfoMap = {};
    purchaseRequest.forEach(p => purchaseInfoMap[p.id] = p);

    const prices = await getPrices(session, orderID, cart);

    for(const product of products) {
        const purchaseInfo = purchaseInfoMap[product.id];
        const priceDetail = prices[product.id];
        const fullProduct = {...product, ...purchaseInfo, ...priceDetail};

        pidToLine[product.id].forEach(orderLine => {
            orderLine.M_Product_ID = fullProduct;
        })
    }
}

const getOrderLinesRequest = async (session, orderID) => {

    const req = request.model(api.MODEL.C_ORDER_LINE)
        .select("C_OrderLine_ID","m_product_ID","m_attributeSetInstance_ID",
            "c_uom_ID","qtyEntered","LineNetAmt", "isBackOrder", "c_charge_ID", "line",
            "QtyOrdered", "PriceEntered")
        .expand("m_attributeSetInstance_ID")
        .filter(condition.eq("C_Order_ID", orderID))
        .filter(condition.greaterThan("M_Product_ID", 0))
        .orderBy('line')
        .buildRequest(env.API_URL);

    const cartItemsResponse = await HttpClient.client.get(req, api.auth(session))
    const cart = { lines: cartItemsResponse.data.records, byID: {}, byPID:{} };

    for(const line of cartItemsResponse.data.records) {
        // Set asi ID to received asi
        // Used for matching to discount
        const asi = line.M_AttributeSetInstance_ID;
        if(asi && asi.id > 0) {
            if(asi.received_asi_ID) {
                line.M_AttributeSetInstance_ID = { id: asi.received_asi_ID.id };
            } else if(asi.X_BaseASI_ID) {
                line.M_AttributeSetInstance_ID = { id: asi.X_BaseASI_ID.id };
            }
        }

        const pid = line.M_Product_ID.id;
        const asiID = line.M_AttributeSetInstance_ID?.id ?? 0;

        cart.byID[line.id] = line;
        if(!cart.byPID[pid]) {
            cart.byPID[pid] = {};
        }
        cart.byPID[pid][asiID] = line;
    }

    await attachProducts(session, orderID, cart);
    return cart;
}

export default getOrderLinesRequest;